import { AddAppAccountRequestPayload } from "@/data/payload/app-account-setting/add-app-account-request-payload";
import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class AddAppAccountUsecase {
  constructor(private readonly appAccountSettingRepo: AppAccountSettingRepository) {}

  async execute(payload: AddAppAccountRequestPayload): Promise<SATResult<void, SATError>> {
    const result = await this.appAccountSettingRepo.addAppAccount(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(void 0);
  }
}
